import { ErrorHandler, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Folder } from '../models';
import { FolderService } from '../services';

export class FolderListBaseComponent implements OnInit, OnChanges {
  @Input()
  folderName: string;

  items: Folder[];

  isProcessing: boolean;

  selectedFolder: Folder;

  @Output()
  selected: EventEmitter<Folder> = new EventEmitter<Folder>();

  constructor(
    private service: FolderService,
    private uxService: ErrorHandler
  ) { }

  ngOnInit() {
    this.fetch();
    this.service.afterCreate.subscribe((data: Folder) => {
      const folder = this.items.find((item) => item.id === data.id);
      if (!folder) {
        this.items.push(data);
        this.onSelect(data);
      }
    });
  }

  ngOnChanges() {
    this.fetch();
  }

  fetch() {
    this.isProcessing = true;

    const query: any = {};

    if (this.folderName) {
      query.name = this.folderName;
    }

    this.service.search(query).subscribe((page) => {
      this.items = page.items;
      if (this.items && this.items.length) {
        this.autoSelect();
      }
      this.isProcessing = false;
    }, (err) => {
      this.isProcessing = false;
      this.uxService.handleError(err.message || err);
    });
  }

  remove(id: string | number) {
    this.isProcessing = true;

    this.service.remove(id).subscribe(() => this.isProcessing = false, (err) => {
      this.isProcessing = false;
      this.uxService.handleError(err.message || err);
    });
  }

  bulkRemove(folders: Folder[]) {
    const rootFolder = folders.find((folder) => folder.name === 'root');
    if (rootFolder) {
      this.uxService.handleError(`You can't remove root folder`);
      return;
    }

    this.service.post(folders, 'deletes').subscribe((data) => {
      if (this.selectedFolder.isDeleted) { this.selectedFolder = null; }
      this.fetch();
      this.isProcessing = false;
    }, (err) => {
      this.isProcessing = true;
      this.uxService.handleError(err.message || err);
    });
  }

  onSelect(folder: Folder) {
    this.items.forEach((item) => {
      if (item.id === folder.id) {
        item.isSelected = true;
        this.selectedFolder = item;
        this.selected.emit(this.selectedFolder);
      } else {
        item.isSelected = false;
      }
    });

  }

  autoSelect() {
    this.selectedFolder = this.selectedFolder || this.items[0];
    this.selectedFolder.isSelected = true;
    this.selected.emit(this.selectedFolder);
  }

}
